import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import { useAccountVesselScope } from '../hooks/useAccountVesselScope';
import { useTheme } from '../contexts/ThemeContext';
import { cn } from '../lib/utils';

const OFFICE_APP_URL = (process.env.REACT_APP_OFFICE_APP_URL || 'http://localhost:3000').replace(/\/$/, '');

/**
 * Vessel portal allows only VESSEL accounts with a linked vessel id.
 * Office/supplier users are blocked and pointed at the office SPA.
 */
const VesselAccessGate: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { colors } = useTheme();
  const { user, isLoading, logout } = useAuth();
  const vesselId = useAccountVesselScope();

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className={colors.textSecondary}>Loading...</div>
      </div>
    );
  }

  const loc = user?.typeLocation != null ? String(user.typeLocation).toUpperCase() : '';
  const isVessel = loc === 'VESSEL';

  if (!isVessel || vesselId == null) {
    return (
      <div className={cn('min-h-screen flex items-center justify-center px-4', colors.background)}>
        <div className={cn('max-w-md w-full rounded-lg border p-6 shadow-sm', colors.surface, colors.border)}>
          <h1 className={cn('text-lg font-semibold mb-2', colors.text)}>Vessel portal only</h1>
          <p className={cn('text-sm mb-4', colors.textSecondary)}>
            This app is for vessel accounts. Office and supplier users should use the main ATLAS application.
          </p>
          <div className="flex flex-wrap gap-3">
            <a
              href={OFFICE_APP_URL}
              className="inline-flex items-center justify-center rounded-md bg-slate-900 px-4 py-2 text-sm font-medium text-white hover:bg-slate-800"
            >
              Open office app
            </a>
            <button
              type="button"
              onClick={() => void logout()}
              className={cn('inline-flex items-center justify-center rounded-md border px-4 py-2 text-sm font-medium', colors.border, colors.text)}
            >
              Sign out
            </button>
          </div>
        </div>
      </div>
    );
  }

  return <>{children}</>;
};

export default VesselAccessGate;
